import {React, useState, forwardRef} from 'react';

import styles from './inputmodal.module.css';

import { useApiProvider } from '../../../providers/ApiProvider';

const InputModal = forwardRef(function InputDialog(props, ref) {

  const { LoadingSpinner } = useApiProvider();

  const inputChange = (e) => {
    props.setInputValue(e.currentTarget.value);
  }

  return (
    <dialog ref={ref} className={styles.Dialog}>
      <div>
        <img className={styles.Close} onClick={props.closeDialog} src='/icons/close-blue.svg'></img><br/>
      </div>
      
      <div className={styles.Body}>
        <div className={styles.Title}>{props.dialogTitle}</div>
        <input 
          className={styles.Input}
          onKeyDown={(e) => props.onSubmit(e)}
          type="password"
          value={props.inputValue == null ? "" : props.inputValue}
          onChange={(e) => inputChange(e)}
          placeholder="Team Code" />
        <button 
          className={styles.Submit} 
          onClick={(e) => props.onSubmit(e)}>{props.isSubmitting ? <LoadingSpinner size={24}/> : 'Submit'}</button>
      </div>
    </dialog>
  )
})

export default InputModal;
